import { render, staticRenderFns } from "./BillingDocumentQuickList.vue?vue&type=template&id=6f072ba2&scoped=true"
import script from "./BillingDocumentQuickList.vue?vue&type=script&lang=js"
export * from "./BillingDocumentQuickList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f072ba2",
  null
  
)

export default component.exports